const brandfolderColorPalette = {
    caution: {
        100: '#FCF8E8',
        200: '#FCEFBB',
        300: '#FCEAA2',
        400: '#FADF87',
        500: '#FCD965',
        600: '#F3B93B',
        700: '#E3992B',
        800: '#B86323',
        900: '#944A12'
    },
    error: {
        100: '#FCEBED',
        200: '#F7D2D7',
        300: '#F2B8BF',
        400: '#E99AA3',
        500: '#E57F8B',
        600: '#DE5B6B',
        700: '#D9384C',
        800: '#C93043',
        900: '#AD2334'
    },
    info: {
        100: '#EEF6FD',
        200: '#D4EAFA',
        300: '#C0E1FA',
        400: '#98CAED',
        500: '#83BBE5',
        600: '#63A4D6',
        700: '#448FC9',
        800: '#3A7DB0',
        900: '#346D99'
    },
    neutrals: {
        0: '#FFFFFF',
        50: '#FAFBFC',
        100: '#F3F5FA',
        200: '#DCDEE5',
        300: '#C1C4CF',
        400: '#8D92A1',
        500: '#6C7182',
        600: '#4E5363',
        700: '#353A4A',
        800: '#252938',
        900: '#101524'
    },
    primary: {
        100: '#EEF2FD',
        200: '#D6DEFA',
        300: '#BFCDFA',
        400: '#93A8EE',
        500: '#728BDE',
        600: '#5874D6',
        700: '#4462C9',
        800: '#3851A6',
        900: '#2B3F80'
    },
    success: {
        100: '#EDFCF9',
        200: '#D0F7EF',
        300: '#B7EBDF',
        400: '#9BDDCF',
        500: '#7FD6C3',
        600: '#52CEB3',
        700: '#2EB297',
        800: '#299E86',
        900: '#1C806B'
    }
};

export { brandfolderColorPalette };
//# sourceMappingURL=colors.js.map
